"use client"

import { useTranslations } from "@/lib/intl/use-translations"
import { track } from "@/lib/analytics"

export interface EscalationActionProps {
  surface: string
  scope: string
  /** Opens the full launcher. */
  onContinueInChat?: () => void
}

const TRIGGER_CLASS =
  "type-body-md inline-flex items-center gap-1 font-medium text-neutral-900 underline-offset-4 hover:underline"

/**
 * The human-escape-hatch on an AI answer. Chatwoot is the only chat backend,
 * so this is a single "Continue in chat" button that opens the full
 * launcher via `onContinueInChat()`.
 */
export function EscalationAction({
  surface,
  scope,
  onContinueInChat,
}: EscalationActionProps): React.ReactNode {
  const t = useTranslations("chat")

  return (
    <button
      type="button"
      className={TRIGGER_CLASS}
      onClick={() => {
        onContinueInChat?.()
        track.aiAnswerEscalated({ surface, scope, target: "chatwoot" })
      }}
    >
      {t("escalation.continue")}
      <span aria-hidden="true">→</span>
    </button>
  )
}
